// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"273":"d69bb61c","370":"8cc49665","459":"c0fcaecf","862":"2b4c9fc6","888":"4499f30d"}[chunkId] + ".chunk.js";
};